// src/modules/tesisat/hooks/useBuatTypeSync.js
//
// Buat tipi kuralını (≤3 hat → yuvarlak, >3 → kare) uygular. Wire slice değiştiğinde
// (priz/aydınlatma/armatür hattı eklendi/silindi) sahnedeki tüm buat'ların tipini
// GEOMETRİK hat sayısına göre günceller (buatTypeUtils.updateAllBuatTypes).
//
// Neden slice'ı izliyoruz: socket/lighting/fixture confirmPlacement fonksiyonları
// çok uzun (~800 satır) ve içine dokunmak riskli. Bunun yerine ekleme olaylarının
// tetiklediği wire-slice değişimini izleyip sahne-geneli idempotent bir güncelleme
// yapıyoruz (yalnız ekleme/silme anında, per-frame değil).

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAllWires } from '../../../redux/wireSlice';
import { updateAllBuatTypes } from '../utils/buatTypeUtils';

export default function useBuatTypeSync(scene) {
  const wires = useSelector(selectAllWires);
  const wireCount = Array.isArray(wires) ? wires.length : 0;

  useEffect(() => {
    if (!scene) return;
    // requestAnimationFrame: confirmPlacement/handleWireEnd sahneyi senkron günceller
    // ama yine de bir frame bekleyerek wire+buat'ın sahnede olduğundan emin ol.
    const id = requestAnimationFrame(() => updateAllBuatTypes(scene));
    return () => cancelAnimationFrame(id);
  }, [scene, wireCount]);
}
